import { ProposalAccessory } from './proposal-services.js';
import { floorAccessoryDefault } from './accessory-choices.js';
const round2 = (n) => Math.round(n * 100) / 100;
const norm = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
/** Drawn trims summed by profile (the app's own name for the profile; its kind when it gave none). Scotia is its own family. */
export function drawnTrims(doc) {
    const by = new Map();
    for (const t of (doc.assessment.plan ?? []).flatMap(f => f.trims)) {
        const profile = (t.profile || t.kind || '').trim();
        if (!profile || /scotia/i.test(profile) || /scotia/i.test(t.kind ?? '') || !(t.length_m && t.length_m > 0))
            continue;
        const held = by.get(profile.toLowerCase()) ?? { profile, length_m: 0 };
        held.length_m += t.length_m;
        by.set(profile.toLowerCase(), held);
    }
    return [...by.values()].map(t => ({ ...t, length_m: round2(t.length_m) })).sort((a, b) => b.length_m - a.length_m || a.profile.localeCompare(b.profile));
}
/** The catalogue trim type a drawn profile is. The app says "Uni Trim" where the catalogue says "Uni Cover", and "L Trim"
 *  where it says "L Trims"; T-Module is the catalogue's "Flat Cover | T-Module". */
export function trimTypeFor(profile, types) {
    return types.find(t => trimProfileMatches(profile, t.name));
}
/** Whether a catalogue product is the drawn profile's type: "Uni Trim" → "Trims - Uni Cover", "L Trim" → "Trims - L Trims". */
export function trimProfileMatches(profile, productName) {
    const p = norm(profile);
    const key = /\bu ?channel\b/.test(p) ? 'u channel' : /\bl ?trims?\b/.test(p) ? 'l trim' : /\buni\b/.test(p) ? 'uni cover' : /\bt ?module\b|\bflat cover\b/.test(p) ? 't module' : p;
    return !!key && norm(productName).includes(key);
}
/** Drawn profiles this floor does not carry yet, with the type each maps to (undefined when the catalogue has none). */
export function missingDrawnTrims(drawn, productId, accessories, types) {
    const held = accessories.filter(a => a.kind === 'trims' && a.bound_to === productId);
    return drawn.map(trim => ({ trim, type: trimTypeFor(trim.profile, types) }))
        .filter(({ trim, type }) => !held.some(a => (a.trim_profile && a.trim_profile.toLowerCase() === trim.profile.toLowerCase()) || (type && a.product_id === type.product_id)));
}
const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 20);
/** One included row per missing drawn profile, bound to the floor. */
export function drawnTrimRows(input) {
    const { drawn, productId, accessories, types, boardThickness, confirmedAccessoryVariantId } = input;
    const room = Math.max(0, 60 - accessories.length);
    return missingDrawnTrims(drawn, productId, accessories, types).slice(0, room).map(({ trim, type }) => {
        const variant = confirmedAccessoryVariantId === undefined && type ? floorAccessoryDefault('trims', type, boardThickness) : null;
        return ProposalAccessory.parse({ id: `trims-drawn:${slug(trim.profile)}:${productId}`.slice(0, 60), kind: 'trims', name: type?.name ?? trim.profile, trim_profile: trim.profile,
            scope: 'site', area_id: '', run_ids: [], colour: null, on: true, bound_to: productId, unit: 'LM', quantity: trim.length_m, quantity_source: 'assessment', rate: null, note: '',
            product_id: type?.product_id ?? null, variant_id: confirmedAccessoryVariantId ?? variant?.variant_id ?? null });
    });
}
//# sourceMappingURL=proposal-drawn-trims.js.map